<div class="flex flex-col gap-4 justify-center items-center text-center h-full my-8">
  <tui-icon class="text-text-error-primary h-12 w-12" icon="@tui.shield-alert" />
  <pxc-title [title]="title" [titleSize]="Size.MEDIUM" />
  <p class="max-w-prose text-sm text-slate-600">{{ subtitle }}</p>
</div>
